import React from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { updateTattooThunk } from "../../apps/tatoosSlice";
import { editTattooSchema } from "../../validations";

const EditTattoo = ({ tattooItem, onClose }) => {
  const dispatch = useDispatch();
  const id = tattooItem?._id; // Ensure tattooItem exists before accessing `_id`

  // Formik Hook
  const formik = useFormik({
    initialValues: {
      id: tattooItem?._id,
      height: tattooItem?.height || "",
      width: tattooItem?.width || "",
      imageUrl: tattooItem?.imageUrl || "",
      thumb: tattooItem?.thumb || "",
    },
    enableReinitialize: true, // Ensures Formik updates when tattooItem changes
    validationSchema: editTattooSchema,
    onSubmit: async (values) => {
      await dispatch(updateTattooThunk({ id, values }));
      onClose();
    },
  });

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Edit Tattoo</h2>

      <form onSubmit={formik.handleSubmit} className="bg-white shadow-md rounded-lg p-6">
        {/* ID */}
        <div className="p-2 rounded mb-2 border" >
          <strong>id:</strong> {formik.values.id}
        </div>
        {/* Height */}
        <div>

          <label className="block text-gray-700">Height</label>
          <input
            type="text"
            name="height"
            value={formik.values.height}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="border p-2 w-full rounded-md mb-2"
          />
          {formik.touched.height && formik.errors.height && (
            <span style={{ color: "red" }}>
              <div>{formik.errors.height}</div>
            </span>
          )}
        </div>

        <div>

          {/* Width */}
          <label className="block text-gray-700">Width</label>
          <input
            type="text"
            name="width"
            value={formik.values.width}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="border p-2 w-full rounded-md mb-2"
          />
          {formik.touched.width && formik.errors.width && (
            <span style={{ color: "red" }}>
              <div>{formik.errors.width}</div>
            </span>
          )}
        </div>

        {/* Image URL */}
        <div>

          <label className="block text-gray-700">Image URL</label>
          <input
            type="text"
            name="imageUrl"
            value={formik.values.imageUrl}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="border p-2 w-full rounded-md mb-2"
          />
          {formik.touched.imageUrl && formik.errors.imageUrl && (
            <span style={{ color: "red" }}>
              <div>{formik.errors.imageUrl}</div>
            </span>
          )}
        </div>

        {/* Image Preview */}
        <div>

          {formik.values.imageUrl && (
            <img
              src={formik.values.imageUrl}
              alt="Tattoo"
              className="w-40 h-40 object-cover rounded-md mb-4"
            />
          )}
        </div>

        {/* Thumbnail */}
        <div>

          <label className="block text-gray-700">Thumbnail</label>
          <input
            type="text"
            name="thumb"
            value={formik.values.thumb}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="border p-2 w-full rounded-md mb-2"
          />
          {formik.touched.thumb && formik.errors.thumb && (
            <span style={{ color: "red" }}>
              <div>{formik.errors.thumb}</div>
            </span>
          )}
        </div>

        {/* Image Preview */}
        <div>

          {formik.values.thumb && (
            <img
              src={formik.values.thumb}
              alt="Tattoo"
              className="w-40 h-40 object-cover rounded-md mb-4"
            />
          )}
        </div>

        {/* Submit Button */}
        <button type="submit" className="bg-black text-white px-4 py-2 rounded-md">
          Update Tattoo
        </button>
      </form>
    </div>
  );
};

export default EditTattoo;
